/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;
export default function init() {
    
    window.addEventListener("load", function () {
        $("#documenttypefilter, #documentlanguagefilter").on("change", function () {
            search();
        });

        searchTypeDropdownEvent();
    });

    window.addEventListener("resize", function () {
        searchTypeDropdownEvent();
    });

    function search() {
        let documentType = $("#documenttypefilter").val();
        let documentLanguage = $("#documentlanguagefilter").val();
        let language = $("#hiddenLanguageCode").val();

        $("#documentsPageLoader").removeClass("d-none");

        $("#productDocs_js").fadeOut();

        // Used for just render the last ajax call
        let seqNumber = ++xhrNumber;

        $.get("/enersysproduct/documentsearch/", {
            pageId: $("#CurrentProduct_ContentGuid").val(),
            documentType: documentType,
            documentLanguage: documentLanguage,
            language: language,
        })
            .done(function (data) {
                $("#productDocs_js").html(data).hide().fadeIn();
            })
            .fail(function (error) {
                if (xhrNumber === seqNumber) {
                    Swal.fire("Oops...", error.statusText, "error");
                    $("#productDocs_js").fadeIn();
                }
            })
            .always(function () {
                if (xhrNumber === seqNumber) {
                    $("#documentsPageLoader").addClass("d-none");
                }
            });
    }

    function searchTypeDropdownEvent(){
        if (window.innerWidth < 767.98) {
            $('#js-select-box').off("change").on("change", function () {
                let dropdown = $('#js-select-box').val();
                $('.tab').hide();
                $('#' + "" + dropdown).show();
            });
        }
    }
}
init();